import React from 'react';
import { IconButton, makeStyles, Theme, Tooltip } from '@material-ui/core';
import { SaveAlt } from '@material-ui/icons';

type Props = {
  exportToXlsx(): void;
};

const useStyles = makeStyles((theme: Theme) => ({
  headerIcon: {
    '&&': {
      padding: theme.spacing(1.5),
      fontSize: theme.spacing(3),
    },
  },
}));

export function ClientSideDataGridExport({ exportToXlsx }: Props): JSX.Element {
  const classes = useStyles();

  return (
    <Tooltip title={'Export to XLSX'} arrow placement="top" data-testid="tooltip-export">
      <IconButton className={classes.headerIcon} size="medium" onClick={exportToXlsx}>
        <SaveAlt data-testid="save-alt-img" />
      </IconButton>
    </Tooltip>
  );
}
